var map = {
	"./Agility-icon.png": "a6ed",
	"./Attack-icon.png": "4bc0",
	"./Constitution-icon.png": "eb9d",
	"./Construction-icon.png": "0cfb4",
	"./Cooking-icon.png": "41de",
	"./Crafting-icon.png": "8c10",
	"./Defence-icon.png": "0f2b",
	"./Dungeoneering-icon.png": "665c",
	"./Farming-icon.png": "d8ac",
	"./Firemaking-icon.png": "8f18",
	"./Fishing-icon.png": "eca3",
	"./Fletching-icon.png": "0e4e",
	"./Herblore-icon.png": "6928",
	"./Hunter-icon.png": "ffff",
	"./Magic-icon.png": "9617",
	"./Mining-icon.png": "33e2",
	"./Overall-icon.png": "2435",
	"./Prayer-icon.png": "b927",
	"./Ranged-icon.png": "9a4a",
	"./Runecrafting-icon.png": "907b",
	"./Slayer-icon.png": "e486",
	"./Smithing-icon.png": "5498",
	"./Strength-icon.png": "ad50",
	"./Summoning-icon.png": "11c2",
	"./Thieving-icon.png": "f1c2",
	"./Woodcutting-icon.png": "3aa1",
	"./bronze.png": "2b28",
	"./gold.png": "46e4",
	"./silver.png": "dfeb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2378";